import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay';
import CustomToolbar from '../../common/datagrid/CustomToolbar';

const EstimateList = ({ columns, rows, loading,handleRowClick }) => {
  return (
    <div style={{ display: 'flex', height: '350px' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGridPro
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '견적서리스트' },
          }}
          loading={loading}
          onRowClick={handleRowClick}
        />
      </div>
    </div>
  );
};

export default EstimateList;
